module.exports = __webpack_public_path__ + "img/20.cbc75fef.png";